<div
  class="rounded-md p-2 bg-stone-50/70 dark:bg-black/30 flex flex-col h-full group relative"
  [ngClass]="
    rule?.isTracked
      ? 'border-2 border-red-500/60 dark:border-red-500/60'
      : rule?.lastErrorType
        ? 'border border-orange-400 dark:border-orange-600'
        : isRuleStale
          ? 'border border-orange-400 dark:border-orange-600'
          : 'border border-neutral-200 dark:border-neutral-700'
  "
>
  <!-- Dimming overlay for stale activation condition -->
  <div
    *ngIf="isActivationConditionStale"
    class="absolute inset-0 bg-white/60 dark:bg-black/60 rounded-md z-10 pointer-events-none"
  ></div>

  <div
    *ngIf="rule?.lastErrorType"
    class="flex items-center gap-1 mb-1.5 px-1.5 py-0.5 bg-red-50 dark:bg-red-950/30 rounded text-xs text-red-600 dark:text-red-400 truncate"
    [title]="errorMessage"
  >
    <i class="pi pi-times-circle shrink-0"></i>
    <span class="truncate">{{ errorMessage || "Erreur de santé" }}</span>
  </div>

  <div
    *ngIf="!rule?.lastErrorType && isRuleStale"
    class="flex items-center gap-1 mb-1.5 px-1.5 py-0.5 bg-orange-50 dark:bg-orange-950/30 rounded text-xs text-orange-600 dark:text-orange-400 truncate"
    title="La règle n'a pas été évaluée depuis plus de 2 fois sa période d'évaluation"
  >
    <i class="pi pi-clock shrink-0"></i>
    <span class="truncate"
      >La règle n'a pas été évaluée depuis plus de 2 fois sa période
      d'évaluation</span
    >
  </div>

  <div class="relative">
    <button
      *ngIf="rule?.uid"
      (click)="onChartClick()"
      class="absolute top-0 right-0 opacity-0 group-hover:opacity-100 transition-opacity p-1.5 rounded hover:bg-neutral-300/50 dark:hover:bg-neutral-600/50 z-10"
      title="Voir les détails"
    >
      <i
        class="pi pi-external-link text-neutral-600 dark:text-neutral-300 text-sm"
      ></i>
    </button>
    <!-- Shared tooltip -->
    <ng-container *ngIf="rule">
      <div
        class="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-max max-w-[280px] p-3 text-xs text-left bg-gray-50 dark:bg-black border border-neutral-300 dark:border-neutral-700 rounded-md shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 invisible group-hover:visible z-[9999] pointer-events-none"
      >
        <div class="space-y-1">
          <p>
            <span class="font-bold text-neutral-600 dark:text-neutral-500"
              >Usine:
            </span>
            <span class="text-neutral-700 dark:text-neutral-300">{{
              rule.functionalLocation?.sapPlantDescription ||
                rule.functionalLocation?.sapPlantId
            }}</span>
          </p>
          <p>
            <span class="font-bold text-neutral-600 dark:text-neutral-500"
              >Groupe planificateur:
            </span>
            <span class="text-neutral-700 dark:text-neutral-300">{{
              rule.functionalLocation?.sapPlannerGroupDescription ||
                rule.functionalLocation?.sapPlannerGroupId
            }}</span>
          </p>
          <p>
            <span class="font-bold text-neutral-600 dark:text-neutral-500"
              >Centre de travail:
            </span>
            <span class="text-neutral-700 dark:text-neutral-300">{{
              rule.functionalLocation?.sapWorkCenterDescription ||
                rule.functionalLocation?.sapWorkCenterId
            }}</span>
          </p>
          <p>
            <span class="font-bold text-neutral-600 dark:text-neutral-500"
              >Contexte:
            </span>
            <span class="text-neutral-700 dark:text-neutral-300">{{
              rule.context
            }}</span>
          </p>
        </div>
        <div
          class="mt-2 pt-2 border-t border-neutral-300 dark:border-neutral-800 space-y-1"
        >
          <p
            *ngIf="
              rule.alertThreshold != null || rule.minAlertThreshold != null
            "
          >
            <span class="font-bold text-neutral-600 dark:text-neutral-500"
              >Valeur du seuil d'alarme:
            </span>
            <span class="text-red-400 font-semibold">{{
              rule.alertThreshold ?? rule.minAlertThreshold
            }}</span>
          </p>
          <p
            *ngIf="
              rule.toleranceThreshold != null ||
              rule.minToleranceThreshold != null
            "
          >
            <span class="font-bold text-neutral-600 dark:text-neutral-500"
              >Valeur du seuil de tolérance:
            </span>
            <span class="text-orange-400 font-semibold">{{
              rule.toleranceThreshold ?? rule.minToleranceThreshold
            }}</span>
          </p>
        </div>
        <div
          class="mt-2 pt-2 border-t border-neutral-300 dark:border-neutral-800 space-y-1"
        >
          <p>
            <span class="font-bold text-red-400"
              >Ratio du seuil d'alarme:
            </span>
            <span class="text-neutral-700 dark:text-neutral-300"
              >{{ animatedEvaluationsPassingMinMaxAlertThresholdRatio }}%</span
            >
          </p>
          <p>
            <span class="font-bold text-orange-400"
              >Ratio du seuil de tolérance:
            </span>
            <span class="text-neutral-700 dark:text-neutral-300"
              >{{
                animatedEvaluationsPassingMinMaxToleranceThresholdRatio
              }}%</span
            >
          </p>
        </div>
        <div
          *ngIf="rule?.lastErrorType || isRuleStale"
          class="mt-2 pt-2 border-t border-neutral-300 dark:border-neutral-800"
        >
          <p
            *ngIf="rule?.lastErrorType"
            class="flex items-center gap-1 text-red-500 dark:text-red-400"
          >
            <i class="pi pi-times-circle shrink-0"></i>
            <span>{{ errorMessage }}</span>
          </p>
          <p
            *ngIf="!rule?.lastErrorType && isRuleStale"
            class="flex items-center gap-1 text-orange-500 dark:text-orange-400"
          >
            <i class="pi pi-clock shrink-0"></i>
            <span
              >La règle n'a pas été évaluée depuis plus de 2 fois sa période
              d'évaluation</span
            >
          </p>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Alert threshold gauge -->
  <div
    class="w-full h-4 bg-neutral-200 dark:bg-neutral-800 rounded-sm border border-neutral-400/40 dark:border-neutral-700 overflow-hidden mb-2"
  >
    <div
      class="h-full rounded-sm transition-all duration-1000 ease-out bg-gradient-to-r from-red-500 via-red-500 to-red-600 dark:from-red-600 dark:via-red-500 dark:to-red-600"
      [style.width.%]="animatedEvaluationsPassingMinMaxAlertThresholdRatio"
    ></div>
  </div>

  <!-- Tolerance threshold gauge -->
  <div
    class="w-full h-4 bg-neutral-200 dark:bg-neutral-800 rounded-sm border border-neutral-400/40 dark:border-neutral-700 mb-2"
  >
    <div
      class="h-full rounded-sm transition-all duration-1000 ease-out bg-gradient-to-r from-amber-500 via-amber-500 to-amber-600 dark:from-yellow-600 dark:via-yellow-500 dark:to-yellow-700"
      [style.width.%]="animatedEvaluationsPassingMinMaxToleranceThresholdRatio"
    ></div>
  </div>

  <ng-container *ngIf="isLoading">
    <div class="flex justify-center">
      <p-progress-spinner
        ariaLabel="loading"
        [style]="{ width: '60px', height: '60px' }"
      />
    </div>
  </ng-container>

  <ng-container *ngIf="!isLoading">
    <div class="flex-grow w-full h-20">
      <canvas
        baseChart
        #canvas
        [datasets]="chartDatasets"
        [options]="lineChartOptions"
        [plugins]="chartPlugins"
        [legend]="false"
        [type]="'line'"
      >
      </canvas>
    </div>
  </ng-container>
</div>
